import { MATH_SCRIPT_SELECTOR, MATH_SCRIPT_TYPE, MATH_SCRIPT_URL, SCRIPT_TAG } from './constants';
export const loadMathScript = async setState => {
  const loadScript = document.querySelector(MATH_SCRIPT_SELECTOR);
  if (loadScript) {
    window.MathJax?.Hub?.Typeset();
    setState(true);
  }
  if (!loadScript) {
    const mathJaxScript = document.createElement(SCRIPT_TAG);
    mathJaxScript.src = MATH_SCRIPT_URL;
    mathJaxScript.type = MATH_SCRIPT_TYPE;
    mathJaxScript.async = true;
    mathJaxScript.onload = () => setState(true);
    document.body.appendChild(mathJaxScript);
  }
};